import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AuditHistory from 'components/modules/shipments/AuditHistory';
import LoadingIndicator from 'components/v2/LoadingIndicator';
import { getCustomerQuickPayAuditEvents } from 'utils/CustomersAPIUtils';
import { showToast } from 'stores/ToastStore';
import { useTranslation } from 'react-i18next';

const History = () => {
  const { t } = useTranslation();
  const { id: accountId } = useParams();
  const [contractAudits, setContractAudits] = useState({
    items: [],
    totalCount: 10,
  });
  const [isLoading, setIsLoading] = useState(true);

  const fetchCustomerQuickPayAuditEvents = async () => {
    try {
      const audits = await (
        await getCustomerQuickPayAuditEvents(accountId, { page: 1, perPage: 200 })
      )?.audits?.items;
      setContractAudits(audits);
    } catch (e) {
      showToast('', t('FETCH_FAILED'), 'error');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomerQuickPayAuditEvents();
  }, []);

  return !isLoading ? (
    <AuditHistory audits={contractAudits} isLoading={isLoading} paginate keepDuplicates />
  ) : (
    <LoadingIndicator />
  );
};

export default History;
